/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e="system",t="unknown",n="UTC",o=Intl.DateTimeFormat().resolvedOptions().timeZone;export{e as system,o as systemTimeZone,t as unknown,n as utc};
